import React, { useCallback, useRef, useState } from 'react';
import {
  exitFullscreen,
  getBrowserFullscreenElementProp,
  toggleFullscreen,
} from '@rsos/utils/fullscreenHelpers';

/**
 * Custom hook that toggles fullscren using the fullscreenRef
 */
const useToggleFullscreen = () => {
  const fullscreenRef = useRef();
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleFullscreen = useCallback(() => {
    if (fullscreenRef.current) {
      if (!isFullscreen) {
        toggleFullscreen(fullscreenRef.current);
      } else {
        exitFullscreen();
      }
    }
  }, [isFullscreen]);

  React.useLayoutEffect(() => {
    document.onfullscreenchange = () => {
      setIsFullscreen(!!document[getBrowserFullscreenElementProp()]);
    };
    return () => {
      document.onfullscreenchange = undefined;
    };
  });

  return [fullscreenRef, handleFullscreen, isFullscreen];
};

export default useToggleFullscreen;
